const getters = {
    activeFacets(state) {
        const active = {};

        state.facets.forEach(group => {
            group.facets.forEach(facet => {
                if (facet.isActive) {
                    if (!active[group.group]) {
                        active[group.group] = []
                    }

                    active[group.group].push(facet.name)
                }
            })
        });

        return active;
    },

    searchQuery(state) {
        return state.query;
    },

    isLoading(state) {
        return state.isLoading;
    },

    sidebarFacets(state) {
        return state.facets.filter(({group}) => group !== '__type');
    },

    typeFacets(state) {
        return state.facets.find(({group}) => group === '__type').facets ?? [];
    },

    getResults(state) {
        return state.results
    },

    yearRange(state) {
        return state.yearRange;
    },

    showPagination(state) {
        return state.showPagination;
    },
    
    getCurrentPage(state) {
        return state.currentPage;
    }
};

export default getters;